<template>
  <div id="welcome">
<!--    <h2>{{ message }}</h2>-->
    <div><img src="../../assets/welcone.png"/> </div>
  </div>
</template>

<script>
export default {
  name: "welcome",
  data () {
    return {
      message: "welcome"
    };
  },
  mounted () {},
  created () {},
  methods: {},

};
</script>

<style scoped lang="scss">
#welcome {
  font-size: 20px;
  div{
    img{
      width: 90%;
      min-width: 700px;
      margin: 50px auto 20px auto;
    }
  }
}
</style>
